import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'

type CustomerContextValue = {
  customerId: string | null
  setCustomerId: (customerId: string | null) => void
}

const CustomerContext = createContext<CustomerContextValue>({
  customerId: null,
  setCustomerId: () => {}
})

export const CustomerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [customerId, setCustomerIdState] = useState<string | null>(null)

  const setCustomerId = useCallback((nextCustomerId: string | null) => {
    setCustomerIdState(nextCustomerId || null)
  }, [])

  const value = useMemo(() => ({ customerId, setCustomerId }), [customerId, setCustomerId])

  return <CustomerContext.Provider value={value}>{children}</CustomerContext.Provider>
}

export const useCustomer = () => {
  const context = useContext(CustomerContext)

  // Defensive: return default value if context is not available
  // This can happen in edge cases like iframe embedding or during initialization
  if (!context) {
    console.warn('[useCustomer] CustomerContext not available, returning default value')
    return {
      customerId: null,
      setCustomerId: () => {}
    }
  }

  return context
}

export const useCustomerId = () => useCustomer().customerId
